import React, { useState } from "react";
import HorizontalSteps from "../../../../ant-components/timeline";
import { useSelector, useDispatch } from "react-redux";
import { postRequest } from "../../../../service/index";
import { message, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { resetForm } from "../../../../redux/slices/employee-slice";
import {
  validateStep,
  validateAllSteps,
  formatMissingFieldsMessage,
} from "../../../../utils/employeeFormValidation";

import {
  Personal,
  Attendance,
  Dependant,
  Official,
  Salary,
  TimeOff,
} from "../../forms";

const AddEmployee = () => {
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);
  const formState = useSelector((state) => state.employeeForm);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const components = {
    0: <Personal />,
    1: <Official />,
    2: <Salary />,
    3: <TimeOff />,
    // 4: <Docs />,
    4: <Dependant />,
    5: <Attendance />,
  };
  const handleNext = () => {
    const missing = validateStep(current, formState);
    if (missing.length > 0) {
      message.error(formatMissingFieldsMessage(missing));
      return;
    }
    setCurrent((prev) => (prev < 5 ? prev + 1 : prev));
  };

  const handleSubmit = async () => {
    const allErrors = validateAllSteps(formState);
    const errorSteps = Object.keys(allErrors).map(Number);

    if (errorSteps.length > 0) {
      const firstInvalidStep = errorSteps[0];
      setCurrent(firstInvalidStep);
      message.error(formatMissingFieldsMessage(allErrors[firstInvalidStep]));
      return;
    }

    try {
      setLoading(true);
      const response = await postRequest("/api/employees", formState);
      if (response.message === "Employee created successfully") {
        message.success("Employee added successfully!");
        dispatch(resetForm());
        navigate("/employees");
      }
      else{
        message.error(response.error || "Employee not added" );
      }
    } catch (error) {
      message.error("Failed to add employee. Please try again.");
      console.error("Error adding employee:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="flex flex-col gap-5 px-4">
      <h4 className="text-2xl font-semibold">Add Employee</h4>
      <HorizontalSteps current={current} />

      <div className="h-auto py-4 p-4 rounded-md mt-5">
        {components[current]}
      </div>
      <div className="border-t border-gray-200 flex justify-end p-4 gap-3 cursor-pointer">
        <Button onClick={() => navigate("/dashboard")} >Cancel</Button>
        {current > 0 && (
          <Button
            className="rounded-full bg-active-color px-4 py-1.5 text-white text-md cursor-pointer"
            onClick={() => setCurrent((prev) => (prev > 0 ? prev - 1 : prev))}
          >
            Back
          </Button>
        )}
        {current < 5 && (
          <Button
            type="primary"
            className="bg-primary text-white"
            onClick={handleNext}
          >
            Next
          </Button>
        )}
        {current === 5 && (
          <Button
            type="primary"
            className="bg-primary text-white"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AddEmployee;

// test
